import { leaseCompanyMst } from '@libs/domain';
import { MstImportTmpl } from '@libs/templates/mst';
import type { PageProps } from '@ps-smart-cp/ppfw-client';
import { withRerender } from '@ps-smart-cp/ppfw-client';
import { importFunction } from './repositories';

function PageComponent(props: PageProps) {
  return (
    <MstImportTmpl mstName={leaseCompanyMst.names.laCompany} importFunction={importFunction} {...props} />
  );
}

export const Import = withRerender(PageComponent, 'Import');
